import Vue from 'vue';
import Router from 'vue-router';

// General
import VariableList from '@/components/VariableList';

// By Sensor Variable
import SensorVariable from '@/components/SensorVariable/Index';
import SensorVariableChart from '@/components/SensorVariable/Chart';
import SensorVariableTable from '@/components/SensorVariable/Table';

// By Station
import Station from '@/components/Station/Index';
import StationObservations from '@/components/Station/Observations';
import StationOverview from '@/components/Station/Overview';

Vue.use(Router);

const router = new Router({
  routes: [
    // {
    //   path: '/all-variables',
    //   name: 'VariableList',
    //   component: VariableList,
    // },
    {
      alias: '/',
      path: '/station/:id?',
      component: Station,
      beforeEnter: (to, from, next) => {
        if (!to.params.id) {
          console.warn('no params!', `${to.path}RCKC1`);
          next({
            name: 'Charts',
            params: {
              id: 'RCKC1',
            },
          });
        } else {
          next();
        }
      },
      children: [
        {
          path: 'overview',
          name: 'Overview',
          component: StationOverview,
        },
        {
          path: '',
          name: 'Charts',
          component: StationObservations,
        },
      ],
    },
    {
      path: '/variable/:id',
      component: SensorVariable,
      children: [
        {
          path: '',
          name: 'SensorVariableChart',
          component: SensorVariableChart,
        },
        {
          path: 'table',
          name: 'SensorVariableTable',
          component: SensorVariableTable,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.clear();
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js